import { render, staticRenderFns } from "./SaleChannel.vue?vue&type=template&id=41464052"
import script from "./SaleChannel.vue?vue&type=script&lang=js"
export * from "./SaleChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports